export default __webpack_public_path__ + "static/media/not-found.9aa411d6.svg";